import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const PaymentModal = ({ message, type, onClose }) => {
  const navigate = useNavigate();
  const bgColor =
    type === "success" ? "#28a745" : type === "error" ? "#dc3545" : "#ffc107";

  // Auto-redirect when modal is mounted
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
      navigate("/home");
    }, 10000); // 10 seconds delay 

    return () => clearTimeout(timer);
  }, [navigate, onClose]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "30px 40px",
          borderRadius: "15px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          position: "relative",
        }}
      >
        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            marginBottom: "20px",
            color: bgColor,
          }}
        >
          {message}
        </div>
        <button
          onClick={() => {
            onClose();
            navigate("/home");
          }}
          style={{
            padding: "10px 20px",
            border: "none",
            borderRadius: "10px",
            background: bgColor,
            color: "#fff",
            cursor: "pointer",
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default PaymentModal;
